import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/journal").then((r) => setPosts(r.data || [])); }, []);

  return (
    <div data-testid="journal-page" className="section-pad">
      <div className="container-pp">
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Pop Panda Journal</div>
        <h1 className="editorial-h1 text-5xl md:text-7xl mt-3">Lab notes, brand notes, kitchen confessions.</h1>
        <div className="mt-12 grid md:grid-cols-2 gap-8">
          {posts.map((p) => (
            <article key={p.id} className="card-elevated overflow-hidden" data-testid={`journal-${p.id}`}>
              {p.cover_url && <img src={p.cover_url} alt={p.title} className="w-full aspect-[16/10] object-cover" />}
              <div className="p-7">
                <div className="text-[10px] uppercase tracking-[0.22em] text-brand-red">{p.author}</div>
                <h3 className="font-display text-3xl mt-2 leading-tight">{p.title}</h3>
                <p className="mt-3 text-brand-charcoal/70 leading-relaxed">{p.excerpt}</p>
                <p className="mt-4 text-sm text-brand-charcoal/70 leading-relaxed">{p.body}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {(p.tags || []).map((t) => (<span key={t} className="text-[10px] uppercase tracking-[0.2em] border border-brand-line rounded-full px-2.5 py-1">{t}</span>))}
                </div>
              </div>
            </article>
          ))}
          {posts.length === 0 && <div className="text-brand-charcoal/60">No journal entries yet.</div>}
        </div>
      </div>
    </div>
  );
}
